module.exports = __webpack_public_path__ + "static/media/clock.b07a202d.svg";